var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_c('div', {
    class: _vm.$style.formWrapper
  }, [_c('div', {
    attrs: {
      "id": "okta-login-widget"
    }
  }), _c('BaseLink', {
    class: _vm.$style.forgotPasswordLink,
    attrs: {
      "to": {
        name: 'requestPasswordReset'
      }
    }
  }, [_vm._v("Forgot my password")])], 1), _vm.promptOnVisit() ? _c('PWAPrompt', {
    attrs: {
      "on-close": _vm.onClosePrompt,
      "copy-body": _vm.promptBodyMessage(),
      "copy-title": _vm.promptTitleMessage(),
      "times-to-show": 9999,
      "permanently-hide-on-dismiss": false
    }
  }) : _vm.promptOnVisitNonIos() ? _c('div', {
    staticClass: "nonIosBrowsers"
  }, [_c('PWAPrompt', {
    attrs: {
      "times-to-show": 9999,
      "on-close": _vm.onClosePrompt,
      "copy-share-button-label": '',
      "copy-add-home-button-label": '',
      "copy-body": _vm.promptBodyMessage(),
      "copy-title": _vm.promptTitleMessage(),
      "permanently-hide-on-dismiss": false
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }